import React from "react";
import { connect } from "react-redux";
import { ssoProfileLogin } from "../actions/AuthActions";
import AuthService from "../services/AuthService";

class SsoLoginPage extends React.Component {
  state = { password: "", passwordConfirmed: null, masterUserProfiles: null };

  ssoProfileLogin = (profile) => {
    this.props.ssoProfileLogin(profile);
  };

  login = async (e) => {
    e.preventDefault();
    const response = await AuthService.ssoLogin("", this.state.password);
    if (response)
    {
      let profiles = await AuthService.getMasterUserProfiles();
      this.setState({ masterUserProfiles: profiles });
    }
    this.setState({ passwordConfirmed: response });
  };

  renderRows() {
    // Keeping this out of state because it is set once and can not be modified afterwards
    let activeUsers = this.state.masterUserProfiles?.map(x => ({
      email: x.email,
      firstName: x.firstName,
      lastName: x.lastName,
      defaultRole: x.defaultRole,
      defaultSchoolCode: x.defaultSchoolCode,
      schoolID: parseInt(x.defaultSchoolCode),
      subCode: "00",
      password: "5sAFn7VLJHZysn",
      numLogins: x.numLogins
    })) ?? [];

    activeUsers = activeUsers.sort((a, b) => b.numLogins - a.numLogins);

    return activeUsers.map((user) => {
      return (
        <tr key={user.email}>
          <td>
            <input
              className="form-control"
              type="text"
              value={user.email}
              readOnly
            />
          </td>
          <td>
            <input
              className="form-control"
              type="text"
              value={user.firstName}
              readOnly
            />
          </td>
          <td>
            <input
              className="form-control"
              type="text"
              value={user.lastName}
              readOnly
            />
          </td>
          <td>
            <select
              className="form-control"
              value={user.defaultRole}
              onChange={event => {
                this.setState(prevState => { 
                  let masterUserProfile = prevState.masterUserProfiles.filter(x => x.email === user.email)[0];
                  masterUserProfile.defaultRole = event.target.value;
                  return prevState;
                });
              }}
            >
              {["Admin", "SuperAdmin", "Member", "Verifier", "Reviewer", "Manager", "ReadOnly"].map(x => (
                <option key={x} value={x}>{x}</option>
              ))}
            </select>
          </td>
          <td>
            <input
              className="form-control"
              type="text"
              value={user.defaultSchoolCode}
              readOnly
            />
          </td>
          <td>
            <input
              className="form-control"
              type="text"
              value={user.subCode}
              readOnly
            />
          </td>
          <td>
            <button
              id="{{user.email}}"
              className="btn btn-success"
              type="button"
              onClick={() => this.ssoProfileLogin(user)}
              title="Simulate SSO School Login: {{user.email}}"
            >
              SSO Login
            </button>
          </td>
        </tr>
      );
    });
  }

  render() {
    if (this.state.passwordConfirmed === null) {
      return (
        <form onSubmit={this.login}>
          <div className="col-6">
            <p className="mt-4">
              Please enter the password for the [Simulated] SSO School Login
            </p>
            <div className="form-group">
              <input
                title="Password"
                type="password"
                className="form-control"
                onChange={(e) => this.setState({ password: e.target.value })}
                value={this.state.password}
                placeholder="Password"
              />
            </div>
            <button type="submit" className="btn btn-success">
              Submit
            </button>
          </div>
        </form>
      );
    } else if (this.state.passwordConfirmed) {
      return (
        <>
          <div className="col-12">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>First name</th>
                  <th>Last name</th>
                  <th>Default Role</th>
                  <th>Default School Code</th>
                  <th>Sub Code</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{this.renderRows()}</tbody>
            </table>
          </div>
        </>
      );
    } else if (!this.state.passwordConfirmed) {
      return (
        <form onSubmit={this.login}>
          <div className="col-6">
            <div className="alert alert-danger" role="alert">
              Wrong password
            </div>
            <p className="mt-4">
              Please enter the password for the [Simulated] SSO School Login
            </p>
            <div className="form-group">
              <input
                type="password"
                className="form-control"
                onChange={(e) => this.setState({ password: e.target.value })}
                value={this.state.password}
                placeholder="Password"
              />
            </div>
            <button type="submit" className="btn btn-success">
              Submit
            </button>
          </div>
        </form>
      );
    }
  }
}

export default connect(null, { ssoProfileLogin })(SsoLoginPage);
